if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.addOnToggle = document.querySelector('#add-on');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      // TD CHANGE START: Guard the vendor spinner hook for product forms that do not render a loading overlay.
      const overlaySpinner = this.querySelector('.loading-overlay__spinner');
      if (overlaySpinner) overlaySpinner.classList.remove('hidden');
      // TD CHANGE END
      document.dispatchEvent(new CustomEvent('theme:loading:start'));

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      const includesAddon = this.addOnToggle ? this.addOnToggle.querySelector('input[name="add-on-radio"]:checked').value === 'true': false;

      if (includesAddon) {
        const addOnId = this.addOnToggle.getAttribute('data-product-id');
        const itemsArray = [];
        const keysToInclude = ['id', 'quantity'];

        for (const [key, value] of formData.entries()) {
          if (keysToInclude.includes(key)) {
            itemsArray.push({ [key]: value });
          }
        }

        itemsArray.push({ id: addOnId, quantity: 1 });

        for (let i = 0; i < itemsArray.length; i++) {
          const obj = itemsArray[i];
          for (const key in obj) {
            formData.append(`items[${i}][${key}]`, obj[key]);
          }
        }

        formData.delete('id');
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          // TD CHANGE START: Keep cleanup safe on templates that omit the vendor loading overlay node.
          if (overlaySpinner) overlaySpinner.classList.add('hidden');
          // TD CHANGE END
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
